import styled from 'styled-components'

export const SystemAuditCardListContainer = styled.div`
    display: flex;
    flex-direction: column;
    /* gap: 8px;
    overflow-y: scroll;
    margin: 0 -64px;
    padding-bottom: 32px; */
    padding: 0 56px;
`

export const CardListNoData = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    padding-bottom: 116px;
`

export const NoInfo = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 20px;
`
